import { Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/app-shell";
import { DashboardPage } from "@/pages/dashboard";
import { RunDetailPage } from "@/pages/run-detail";
import { NotFoundPage } from "@/pages/not-found";

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/runs/:id" element={<RunDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
